import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { signupActions } from '~/services/signup';
import { useMount } from '~/services/utils/hooks';
import LandingTemplate from '~/templates/LandingV2';
import usePricing from '~/components/usePricing';
import { Translation, LocalizedCurrency } from '~/components/Translation';

const FriendLandingTemplate = ({ image, name, referrerClick, referrerId }) => {
	const { referralPricing } = usePricing();

	// Save that user signed up through this page
	useMount(() => {
		referrerClick({ referrer: referrerId, referrerType: 'affiliate' });
	});

	return (
		<LandingTemplate
			heading={<Translation tid="landing.title" />}
			recommendedBy={{
				image,
				text: (
					<Translation
						tid="landing.partners.referrerDescription"
						values={{
							name,
						}}
						components={{
							creditAmount: (
								<LocalizedCurrency
									value={referralPricing.referredCredit}
									minimumFractionDigits={0}
								/>
							),
						}}
					/>
				),
			}}
			subHeading={<Translation tid="landing.subtitle.v2" />}
		/>
	);
};

FriendLandingTemplate.propTypes = {
	image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	name: PropTypes.string.isRequired,
	referrerClick: PropTypes.func.isRequired,
	referrerId: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
	referrerClick: signupActions.referrerClick,
};

export default connect(null, mapDispatchToProps)(FriendLandingTemplate);
